import { create } from "zustand";

const useLinkJDStore = create((set) => ({
    islinkJDModelOpen: false,
    setLinkJDModalOpen: () => {
        set({ islinkJDModelOpen: true });
    },
    handleLinkJDModalOk: () => {
        set({ islinkJDModelOpen: false });
    },
    handleLinkJDModalCancel: () => {
        set({ islinkJDModelOpen: false });
    },
}));

export default useLinkJDStore;
